import { useEffect, useState } from 'react';
import { getSaasOrganization } from '../Utils/saasOrganization';

export function useOrganizationCredits(isUserLoggedIn, organizationId, subscribeToMessages) {
  const [snapshot, setSnapshot] = useState(null);
  useEffect(() => {
    setSnapshot(null);
    if (!isUserLoggedIn || !organizationId) return undefined;
    let active = true;
    let inFlight = false;
    let refreshAgain = false;
    let timer;
    const schedule = (delay) => {
      clearTimeout(timer);
      timer = setTimeout(refresh, delay);
    };
    const refresh = async () => {
      if (inFlight) {
        refreshAgain = true;
        return;
      }
      inFlight = true;
      try {
        const result = await getSaasOrganization(organizationId);
        if (!active) return;
        if (String(result.organization_id) !== String(organizationId)) {
          schedule(61000);
          return;
        }
        if (result.state === 'existing') return;
        const balance = Number(result.credits);
        if (result.credits != null && Number.isFinite(balance)) {
          setSnapshot({ organizationId, credits: Math.max(0, balance) });
        }
        if (result.state === 'provisioning') schedule(61000);
      } catch (error) {
        if (active) {
          console.warn('Unable to refresh organization credits:', error?.message || error);
          // A 401 requires session restoration or sign-in; repeating the same
          // unauthorized request every minute cannot repair authentication.
          if (error?.status !== 401) schedule(61000);
        }
      } finally {
        inFlight = false;
        if (active && refreshAgain) {
          refreshAgain = false;
          schedule(250);
        }
      }
    };
    const unsubscribe = subscribeToMessages(message => {
      // Configuration messages lack organization identity; re-read the scoped balance.
      if (message.command === 'configuration_data') schedule(250);
    });
    void refresh();
    return () => {
      active = false;
      clearTimeout(timer);
      unsubscribe();
    };
  }, [isUserLoggedIn, organizationId, subscribeToMessages]);
  return isUserLoggedIn && snapshot?.organizationId === organizationId ? snapshot.credits : null;
}
